<div class="activities container-large d-flex">
	<div class="activities-column" class="aside__section">
		<h2 class="aside__heading">{{this.word[this.language].lastVisited}}</h2>
		<a [routerLink]="'/' + language == 'en'
		? language + '/' + item?.id + '/' + toLatin(item?.name)
    : item?.id + '/' + toLatin(item?.name)"
       *ngFor="let item of lastActions?.visited"
			class="news activity-box"
			title="{{ this.language == 'bg' ? item?.name : item?.name_uk}}, {{this.word[this.language].lastVisited}}">
			<h3 class="ellipsis">
				{{ this.language == 'bg' ? item?.name : item?.name_uk}}
			</h3>
			<p class="date">
				<i class="fa fa-clock-o"></i> {{item.visited}}
			</p>
		</a>
	</div>

	<div class="activities-column" class="aside__section">
		<h2 class="aside__heading">{{this.word[this.language].lastActive}}</h2>
		<a [routerLink]="'/' + language == 'en'
		? language + '/' + item?.id + '/' + toLatin(item?.name)
    : item?.id + '/' + toLatin(item?.name_uk)"

       *ngFor="let item of lastActions?.active"
			class="news activity-box"
			title="{{ this.language == 'bg' ? item?.name : item?.name_uk}}, {{this.word[this.language].zavedenia}}">
			<h3 class="ellipsis">
        {{this.language == 'bg' ? item?.name : item?.name_uk}}
			</h3>
			<p class="date">
				<i class="fa fa-clock-o"></i> {{item.visited}}
			</p>
		</a>
	</div>

	<div class="activities-column" class="aside__section">
		<h2 class="aside__heading">{{this.word[this.language].lastReservations}}</h2>
		<a [routerLink]="'/' + language == 'en'
		? language + '/' + item?.id + '/' + toLatin(item?.name)
    : item?.id + '/' + toLatin(item?.name_uk)"
       *ngFor="let item of lastActions?.reservations"
			class="news activity-box"
			title="{{this.language == 'bg' ? item?.name : item?.name_uk}}, {{this.word[this.language].lastReservations}}">
			<h3 class="ellipsis">
				{{this.language == 'bg' ? item?.name : item?.name_uk}}
			</h3>
			<p class="date">
				<i class="fa fa-clock-o"></i> {{item.visited}}
			</p>
		</a>
	</div>
</div>
